import { useState, useEffect, type ReactNode } from "react";
import { apiService } from "@/services/apiService";
import { PartnerCourtesyPage } from "@/pages/PartnerCourtesyPage/PartnerCourtesyPage";
import { useTranslations } from "@/hooks/useTranslations";
import { LoadingSpinner } from "@/components/shared/LoadingSpinner/LoadingSpinner";

interface IPartnerGuardProps {
  children: ReactNode;
}

export function PartnerGuard({ children }: IPartnerGuardProps): ReactNode {
  const [partnerStatus, setUserStatus] = useState<{ isValidUser: boolean } | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslations();

  useEffect(() => {
    async function checkUserStatus(): Promise<void> {
      try {
        setIsLoading(true);
        const partnerDetails = await apiService.getUserDetails();
        setUserStatus({ isValidUser: partnerDetails.isPartner || partnerDetails.isMicrosoftUser });
      } catch {
        setUserStatus({ isValidUser: false });
      } finally {
        setIsLoading(false);
      }
    }

    checkUserStatus();
  }, []);

  if (isLoading) {
    return <LoadingSpinner message={t("partnerGuard.checkingAccess")} fullScreen />;
  }

  if (!partnerStatus?.isValidUser) {
    return <PartnerCourtesyPage />;
  }

  return children;
}